import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useDispatch, useSelector } from "react-redux";
import PlacePicker from "components/MDPlacePicker/PlacePicker";
import { isEmpty } from "lodash";
import { getBootings } from "store/slice/bootingRevenue/bootingRevenueSlice";
import BootingTable from "./components/BootingTable";
import CreateBooting from "./components/CreateBooting";

function BootingRevenue() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const userData = useSelector((state) => state.users?.meInfo);
  const bootingsData = useSelector(
    (state) => state.bootingRevenue?.bootingList || []
  );
  const roleModules = userData?.roleModules || {};

  const placesList = useSelector((state) => state.places?.placesList);
  const placesData = useSelector((state) => state.places?.selectedPlace);
  let placeId = placesData?._id;

  const handleGetBootings = () => {
    dispatch(getBootings(placeId)).unwrap();
  };
  useEffect(() => {
    handleGetBootings();
  }, [placeId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <MDBox pt={2} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={1}
                  mt={-2}
                  py={1}
                  px={1}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow={sidenavColor}
                  className="d-flex align-items-center gap-2"
                >
                  <MDTypography
                    variant="h6"
                    color="white"
                    className="flex-grow-1"
                  >
                    Booting Revenue
                  </MDTypography>

                  {roleModules.Booting_revenue_add && (
                    <MDButton
                      variant="outlined"
                      size="small"
                      onClick={() => setDialogOpen(true)}
                    >
                      Create
                    </MDButton>
                  )}
                </MDBox>
                <MDBox p={2}>
                  <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                      <PlacePicker />
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox pt={3}>
                  <BootingTable
                    placeId={placeId}
                    bootingData={!isEmpty(bootingsData) ? bootingsData : []}
                    roleModules={roleModules}
                  />
                  <CreateBooting
                    tz={placesData?.timeZoneId}
                    placeId={placeId}
                    dialogOpen={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    placesList={placesList}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BootingRevenue;
